document.addEventListener('DOMContentLoaded', function () {
    const productCards = document.querySelectorAll('.product-card-slug');

    productCards.forEach(card => {
        const images = card.querySelector('.product-image-slug');

        const bulletsContainer = card.querySelector('.bullets-container-slug');
        const productCard = card;

        let currentIndex = 0;
        const totalImages = images.children.length;

        // Create bullets for each image
        for (let i = 0; i < totalImages; i++) {
            const bullet = document.createElement('div');
            bullet.classList.add('bullet');
            if (i === 0) bullet.classList.add('active');
            bulletsContainer.appendChild(bullet);

            // Update image when bullet is clicked
            bullet.addEventListener('click', function () {
                showImage(i);
            });
        }

        // Reset to first image when group is unhovered
        productCard.addEventListener('mouseleave', function () {
            currentIndex = 0;
            showImage(currentIndex);
        });
    });

    // Mobile-specific functionality
    const imagesContainers = document.querySelectorAll('.product-image-slug');
    const bulletsContainers = document.querySelectorAll('.bullets-container-slug');

    imagesContainers.forEach((imagesContainer, index) => {
        const bulletsContainer = bulletsContainers[index];

        let startX = 0;
        imagesContainer.addEventListener('touchstart', function (e) {
            startX = e.touches[0].clientX;
        });

        imagesContainer.addEventListener('touchmove', function (e) {
            const currentX = e.touches[0].clientX;
            const diff = startX - currentX;
            startX = currentX;
        });

        imagesContainer.addEventListener('scroll', function () {
            const scrollLeft = imagesContainer.scrollLeft;
            const imageWidth = imagesContainer.offsetWidth;
            const activeIndex = Math.floor(scrollLeft / imageWidth * 1.1);
            const bullets = bulletsContainer.querySelectorAll('.bullet');
            bullets.forEach((bullet, i) => {
                if (i === activeIndex) {
                    bullet.classList.add('active');
                } else {
                    bullet.classList.remove('active');
                }
            });
        });
    });
});
